const accordionId = 'pregnancy-accordion';
const outOfPocketSectionId = 'out-of-pocket';
const mobileThreshold = '60rem';
const outOfPocketSectionIndex = 2;

export { accordionId, mobileThreshold, outOfPocketSectionId, outOfPocketSectionIndex };
